export enum SmsSubscription {
  ManualEnabled = 'enabled_manually',
  ManualDisabled = 'disabled_manually',
  TwilioEnabled = 'enabled_by_twilio',
  TwilioDisabled = 'disabled_by_twilio',
}
